import { render, staticRenderFns } from "./UserAssetAddresses.vue?vue&type=template&id=cc799268"
import script from "./UserAssetAddresses.vue?vue&type=script&lang=js"
export * from "./UserAssetAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports